// extracted by mini-css-extract-plugin
module.exports = {"title":"Error_title__p-NFR"};